import { useCallback } from 'react';

export const useAnalytics = () => {
  const pushToDataLayer = useCallback((eventData) => {
    window.dataLayer = window.dataLayer || [];
    const enrichedData = {
      ...eventData,
      BrandName: 'Corp Web',
      VariantName: 'NA',
    };
    window.dataLayer.push(enrichedData);
  }, []);
  return { pushToDataLayer };
};
